module.exports = __webpack_public_path__ + "static/media/Formica.794cf166.svg";